<template>
  <section>
    <img
      :src="orderStatusGifs[status]"
      class="order-status-image"
      :alt="status"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["status"],
  data() {
    return {
      orderStatusGifs: {
        pending: require("@/assets/images/order_status/order-pending.gif"),
        in_process: require("@/assets/images/order_status/order-processing.gif"),
        dispatched: require("@/assets/images/order_status/order-dispatched.gif"),
        pick_up: require("@/assets/images/order_status/order-dispatched.gif"),
        delivered: require("@/assets/images/order_status/order-delivered.gif"),
        claimed: require("@/assets/images/order_status/order-delivered.gif")
      }
    };
  },
  computed: {
    ...mapGetters("design", [
      "pendingDesign",
      "processingDesign",
      "dispatchedDesign",
      "pickupDesign",
      "deliveredDesign",
      "claimedDesign"
    ])
  },
  created() {
    if (this.pendingDesign && this.pendingDesign.header_image)
      this.orderStatusGifs.pending = this.pendingDesign.header_image;
    if (this.processingDesign && this.processingDesign.header_image)
      this.orderStatusGifs.in_process = this.processingDesign.header_image;
    if (this.dispatchedDesign && this.dispatchedDesign.header_image)
      this.orderStatusGifs.dispatched = this.dispatchedDesign.header_image;
    if (this.pickupDesign && this.pickupDesign.header_image)
      this.orderStatusGifs.pick_up = this.pickupDesign.header_image;
    if (this.deliveredDesign && this.deliveredDesign.header_image)
      this.orderStatusGifs.delivered = this.deliveredDesign.header_image;
    if (this.claimedDesign && this.claimedDesign.header_image)
      this.orderStatusGifs.claimed = this.claimedDesign.header_image;
  }
};
</script>

<style scoped>
.order-status-image {
  max-height: 268px;
  height: 100%;
  width: 100%;
}
</style>
